<template>
  <div>
    <vm-table
        ref="vmTable"
        height="70Vh"
        :filter.sync="filter"
        module="basic"
        url="processExceptions/qualityJudgmentList">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="单号">
            <el-input v-model="filter.billNo"/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model="filter.factoryNo"/>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model="filter.creatorName"/>
          </vm-search>
          <vm-search label="是否判责">
            <el-select v-model="filter.isJudgment" clearable placeholder="请选择">
              <el-option label="是" :value="true"/>
              <el-option label="否" :value="false"/>
            </el-select>
          </vm-search>
          <vm-search label="开单时间:">
            <div>
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd 00:00:00"
                  type="date"
                  style="width: 190px"
                  placeholder="请选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至:">
            <div>
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="expand" width="60">
        <template slot-scope="scope">
          <el-table :data="scope.row.processExceptionMaterialVOS">
            <el-table-column prop="materialNo" label="物料编号" align="center"/>
            <el-table-column prop="materialName" label="物料描述" align="center"/>
            <el-table-column prop="badNum" label="不良数量" align="center"/>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="billNo" label="单号" align="center" width="160"/>
      <el-table-column prop="factoryNo" label="出厂编号" align="center"/>
      <el-table-column prop="customerName" label="客户名称" align="center"/>
      <el-table-column prop="createTime" label="创建时间" align="center" width="160"/>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">待提交</span>
          <span v-else-if="scope.row.status === 5">已退回</span>
          <span v-else-if="scope.row.status === 10">已提交</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
        </template>
      </el-table-column>
      <quality-judgment-edit ref="editPage" @save-success="getList(1)"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";
  import QualityJudgmentEdit from "@/views/purchase/processException/QualityJudgmentEdit";

  export default {
    name: "QualityJudgmentList",
    components: {QualityJudgmentEdit, VmTable, VmSearch},
    data() {
      return {
        filter: {
          billNo: "",
          creatorName: "",
          factoryNo: "",
          beginCreateTime: "",
          endCreateTime: "",
          isJudgment: false,
        },
        tableData: {},
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };

</script>

<style>

</style>